import _uniqBy from 'lodash.uniqby';

export function uniqBy<T = any>(collection: T[], id: string) {
  return _uniqBy(collection, id);
}
